<template>
  <Section>
    <template v-slot:section-body>
      <form>
        <div class="row">
          <div class="col-md-8">
            <FormGroup>
              <h5 class="name">ชื่อผัง</h5>
              <input type="text"
                placeholder="ชื่อผัง"
                :value="schedule.name"
                @blur="checkRequired"
                @input="$emit('update:schedule', { ...schedule, name: $event.target.value })"
                class="form-control"
                :class="{'is-invalid': saveScheduleStateError.name}"/>
            <div
              class="invalid-feedback"
              v-if="saveScheduleStateError.name">
               ระบุคำชื่อผัง
              </div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">ชื่อผังแบบย่อ</h5>
              <input type="text"
              :value="schedule.shortName"
              placeholder="ชื่อผังแบบย่อ"
              @input="$emit('update:schedule', { ...schedule, shortName: $event.target.value })"
              class="form-control"/>
            </FormGroup>
            <FormGroup class="underline pb-2">
              <ImageField
                :image.sync="schedule.imagePlain"
                aspectRatio="original"
                title="อัปโหลดรูปภาพ (ข้อมูล)"
                emptyMessageText="ยังไม่มีรูปข้อมูล"
                hintText="ขนาดความกว้างที่เหมาะสม 1920px"
                imageViewSize="content1920w" />
            </FormGroup>
            <FormGroup>
              <ImageField
                :image.sync="schedule.image"
                aspectRatio="original"
                title="อัปโหลดรูปภาพ (ข้อมูล, ภาพ)"
                emptyMessageText="ยังไม่มีรูปข้อมูล"
                hintText="ขนาดความกว้างที่เหมาะสม 1920px"
                imageViewSize="content1920w" />
            </FormGroup>
            <FormGroup>
              <PdfManagement
                :pdf.sync="schedule.pdf">
                <template v-slot:coverPdfHeader="{ choosePdf }">
                  <h5 class="name">อัปโหลดไฟล์ PDF</h5>
                    <div class="actions">
                      <button
                        type="button"
                        class="btn btn-link"
                        @click.stop="choosePdf">
                        เลือกไฟล์
                      </button>
                    </div>
                </template>
                <template v-slot:pdfContainer>
                  <small v-if="schedule.pdf===null">ยังไม่มีไฟล์</small>
                  <div v-if="schedule.pdf!==null">
                    <a class="file-info"
                      target="_blank"
                      @click.stop="download(getPdfName(), getPdfUrl())">
                      <div class="info--icon">
                        <i class="fas fa-file-pdf"></i>
                      </div>
                      <div class="info--meta ml-2">
                        {{getPdfName()}}
                        <i class="fas fa-file-download"></i>
                      </div>
                    </a>
                  </div>
                </template>
              </PdfManagement>
            </FormGroup>
          </div>
          <div class="col-md-4">
            <FormGroup>
              <h5 class="name">สถานะการเผยแพร่</h5>
              <ContentStatusManagement
                :status="schedule.status"
                :startPublish="schedule.startPublish"
                :endPublish="schedule.endPublish"
                :onChange="onChangeStatus"/>
            </FormGroup>
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
import _ from 'lodash';
import downloadNameInjector from '@/utils/downloadNameInjector';
import Section from '@/components/Section.vue';
import FormGroup from '@/components/FormGroup.vue';
import ContentStatusManagement from '@/contentStatus/ContentStatusManagement.vue';
import ImageField from '@/image/ImageField.vue';
import PdfManagement from '@/pdf/PdfManagement.vue';

export default {
  mixins: [downloadNameInjector],
  components: {
    Section,
    FormGroup,
    ImageField,
    ContentStatusManagement,
    PdfManagement,
  },
  props: {
    schedule: {
      type: Object,
      default: () => {},
    },
    saveScheduleStateError: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getPdfName() {
      return _.get(this.schedule, 'pdf.name', null);
    },
    getPdfUrl() {
      return _.get(this.schedule, 'pdf.url', null);
    },
    onChangeStatus(newStatus) {
      this.$emit('update:schedule', {
        ...this.schedule,
        status: newStatus.status,
        startPublish: newStatus.startPublish,
        endPublish: newStatus.endPublish,
      });
    },
    checkRequired(event) {
      if (!event.target.value) {
        this.$emit('update:saveScheduleStateError', { ...this.saveScheduleStateError, name: 'ระบุคำบรรยายป้าย' });
      } else {
        this.$emit('update:saveScheduleStateError', { ...this.saveScheduleStateError, name: null });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';
.underline {
  border-bottom: 1px solid $gray-100;
}
.file-info {
  display:flex;
  align-items: center;
  cursor: pointer;
}
</style>
